import submitTarget from './submit-target'

export const targetNext = () => () => {
	const modelhelper = window.seatingChartVars.isHelping
	const {notCookieCustomer} = window.seatingChartVars

	// submitTarget function is from: /theme/shenyunmobile/javascripts/src/script/best-available.js
	submitTarget(
		modelhelper,
		notCookieCustomer,
	)
}
